import { Webcontent } from "src/app/_utils/_tipos/webcontent";

export class CifrasWebSego extends Webcontent
{
  inversores: number;
  inversoresRegistrados: number;
  inversiones: number;
  invertidos: number;
  empresasCotizadas: number;
  financiados: number;
  operaciones: number;
  rentabilidadMedia: number;
  rentabilidadAnualAseguradas: string;
  rentabilidadAnualNoAseguradas: string;
  rentabilidadAnualAdminPublica: string;
  plazoMedioFactura: number;
  invertidoAutoinvest: number;
  inversionesCada10Autoinvest: number;
  invertidoPorMinutoAutoinvest: number;
  pymesAyudadas: number;
  financiadoPymes: number;
  inversoresRecurrentesPymes: number;
  inversoresPymes: number;
  operacionesDisputaPymes: number;
  cuentaRemunerada: number;
  depositos: number;
  carteras: number;
}
